import axios from 'axios';
import ApiURL from './ApiURL';
import { CreateResponse, AxiosCreateResponse } from '../interfaces/IResponses';
import { handleError } from './HandleError';
import { ContactInputDto, ContactOutputDto } from '../interfaces/IContact';

const API_URL = ApiURL() + 'services/app/contact';

class ContactService {

    async Create(input: ContactInputDto): Promise<CreateResponse<ContactOutputDto>> {
        return axios.post<AxiosCreateResponse<ContactOutputDto>>(API_URL + '/Create', input)
            .then(response => {
                return {
                    success: true,
                    response: response.data
                };
            })
            .catch((error) => handleError(error, 'Save error, please check your internet connection.'));
    }
}

export default new ContactService();